/**
 * Data Models
 */

export interface ProperNoun {
  novelId: string;
  properNounId: string;
  name: string;
  /** 定義済みカテゴリ（ProperNounCategoryType）またはカスタムカテゴリのID（ProperNounCustomCategory.properNounCustomCategoryId） */
  properNounCategory: ProperNounCategoryType | string;
  /** 紐付け資料の種別。定義済み（ProperNounLinkedAttributeType）のほか、将来のカスタム資料属性も許容する */
  materialAttribute?: ProperNounLinkedAttributeType | string;
  materialId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface ProperNounCustomCategory {
  novelId: string;
  properNounCustomCategoryId: string;
  name: string;
  createdAt?: string;
  updatedAt?: string;
}

export const ProperNounCategory = {
  CHARACTER_NAME: "characterName",
  PLACE_NAME: "placeName",
  ITEM: "item",
  ABILITY: "ability",
  TERM: "term",
} as const;
// eslint-disable-next-line no-redeclare
export type ProperNounCategoryType = (typeof ProperNounCategory)[keyof typeof ProperNounCategory];

export const ProperNounLinkedAttribute = {
  CHARACTER: "character",
  WORLDVIEW: "worldview",
} as const;
// eslint-disable-next-line no-redeclare
export type ProperNounLinkedAttributeType = (typeof ProperNounLinkedAttribute)[keyof typeof ProperNounLinkedAttribute];

/**
 * Request Models
 */

export interface CreateProperNoun {
  novelId: string;
  properNounId?: string;
  name: string;
  /** 定義済みカテゴリ（ProperNounCategoryType）またはカスタムカテゴリのID */
  properNounCategory: ProperNounCategoryType | string;
  /** 紐付け資料の種別。定義済み（ProperNounLinkedAttributeType）のほか、将来のカスタム資料属性も許容する */
  materialAttribute?: ProperNounLinkedAttributeType | string;
  materialId?: string;
}

export interface UpdateProperNoun {
  novelId: string;
  properNounId: string;
  name?: string;
  /** 定義済みカテゴリ（ProperNounCategoryType）またはカスタムカテゴリのID */
  properNounCategory?: ProperNounCategoryType | string;
  /** 紐付け資料の種別。定義済み（ProperNounLinkedAttributeType）のほか、将来のカスタム資料属性も許容する。null は紐付け解除を表す */
  materialAttribute?: ProperNounLinkedAttributeType | string | null;
  /** 紐付け資料のID。null は紐付け解除を表す */
  materialId?: string | null;
}

export interface DeleteProperNoun {
  novelId: string;
  properNounId: string;
}

export interface CreateProperNounCustomCategory {
  novelId: string;
  properNounCustomCategoryId?: string;
  name: string;
}

export interface UpdateProperNounCustomCategory {
  novelId: string;
  properNounCustomCategoryId: string;
  name: string;
}

export interface DeleteProperNounCustomCategory {
  novelId: string;
  properNounCustomCategoryId: string;
}

/**
 * View Models
 */

/** 固有名詞管理モーダルのタブ定義（UI 表示用） */
export interface ProperNounTab {
  id: string;
  label: string;
  type: "character" | "worldView" | "materialAttribute" | "properNounCategory" | "customCategory" | "uncategorized";
  categoryValue?: string;
  customCategoryId?: string;
  /** materialAttribute タブの場合の資料種別ID（ユーザ作成のカスタム属性のみ） */
  attributeId?: string;
}
